import {
  Container,
  CssBaseline,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import AboutUs from "./components/AboutUs";
import Events from "./components/Events";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Contact from "./components/Contact";
import ScrollButton from "./components/ScrollButton";
import Author from "./components/Author";
import Members from "./components/Members";
import MembersLabels from "./components/MembersLabels";
import Hyperfocal from "./components/Hyperfocal";
import GoldenHour from "./components/GoldenHour";
import Moon from "./components/Moon";
import News from "./components/News";
import Tools from "./components/Tools";
import HowTo from "./components/HowTo";
import { useLayoutEffect } from "react";

//import "./assets/bodyBorder.css";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#3ab6fe",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#ee217e",
      contrastText: "#FFFFFF",
    },
    fucsia: { main: "#ee217e", contrastText: "#FFFFFF" },
    amarillo: { main: "#ffff01", contrastText: "#112A46" },
    celeste: { main: "#3ab6fe", contrastText: "#FFFFFF" },
    lila: { main: "#c768e0", contrastText: "#FFFFFF" },
    gris: { main: "#545359", contrastText: "#FFFFFF" },
  },
  components: {
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#c768e0",
          color: "white",
        },
        colorSecondary: {
          backgroundColor: "#ffff01",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "bottomBorder" },
              style: {
                borderBottom: "2px solid",
                borderRadius: "0",
              },
            },
          ],
        },
      },
    },
  },
});

const ContainerCentered = ({ children }) => (
  <Container
    component="main"
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      py: 2,
    }}
  >
    {children}
  </Container>
);

const GalleryPage = () => {
  return (
    <Container
      component="main"
      maxWidth="100%"
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Gallery />
    </Container>
  );
};

const EventsPage = () => {
  return (
    <ContainerCentered>
      <Events />
    </ContainerCentered>
  );
};

const NewsPage = () => {
  return (
    <ContainerCentered>
      <News />
    </ContainerCentered>
  );
};

const App = () => {
  const location = useLocation();
  // Scroll to top if path changes
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Header />

      <ScrollButton />

      <Routes>
        <Route path="/">
          <Route index element={<Navigate to="/gallery" />} />

          <Route path="gallery">
            <Route index element={<GalleryPage />} />

            <Route path=":albumName" element={<GalleryPage />} />
          </Route>

          <Route path="events">
            <Route index element={<EventsPage />} />

            <Route path=":eventId" element={<EventsPage />} />
          </Route>

          <Route path="news">
            <Route index element={<NewsPage />} />

            <Route path=":newsId" element={<NewsPage />} />
          </Route>

          <Route
            path="contact"
            element={
              <ContainerCentered>
                <Contact />
              </ContainerCentered>
            }
          />

          <Route
            path="about"
            element={
              <ContainerCentered>
                <AboutUs />
              </ContainerCentered>
            }
          />

          <Route path="author">
            <Route
              path=":authorID"
              element={
                <ContainerCentered>
                  <Author />
                </ContainerCentered>
              }
            />
          </Route>

          <Route path="members">
            <Route index element={<Members />} />

            <Route path="labels" element={<MembersLabels />} />
          </Route>

          <Route path="tools">
            <Route
              index
              element={
                <ContainerCentered>
                  <Tools />
                </ContainerCentered>
              }
            />

            <Route
              path="hiperfocal"
              element={
                <ContainerCentered>
                  <Hyperfocal />
                </ContainerCentered>
              }
            />

            <Route
              path="goldenhour"
              element={
                <ContainerCentered>
                  <GoldenHour />
                </ContainerCentered>
              }
            />

            <Route
              path="moon"
              element={
                <ContainerCentered>
                  <Moon />
                </ContainerCentered>
              }
            />
          </Route>
        </Route>

        <Route
          path="how-to"
          element={
            <ContainerCentered>
              <HowTo />
            </ContainerCentered>
          }
        />
      </Routes>

      <Footer />
    </ThemeProvider>
  );
};

export default App;
